export default __webpack_public_path__ + "static/media/coursePlaceholder.457a6448.png";